/*
Copyright MITSUBISHI Elec.
*/

/**
 BlenderGrid用の汎用セルスタイル

Blender標準セル(標準のマッピング定義済)
セル種別名称は、クラス名の接頭子「eXcell_」以降になる。

| セル種別名称   | 編集可否   | セル種別の説明            |
|:---------------|:-----------|:--------------------------|
| bl_ed          | 編集可     | Blender編集セル |
| bl_ro          | 編集不可   | Blender編集セル(ReadOnly) |
| bl_edn         | 編集可     | Blender数値編集セル |
| bl_ron         | 編集不可   | Blender数値編集セル版(ReadOnly) |
| bl_edk         | 編集可     | 漢字用編集セル(編集開始時IME-ON) |
| bl_eda         | 編集可     | アルファベット用編集セル(IME無効) |
| bl_edsp        | 編集可     | Blender編集セル(Trim整形なし)|
| bl_rosp        | 編集不可   | Blender編集セル(ReadOnly、Trim整形なし)|
| bl_html        | 編集可     | Html編集セル(ReadOnly) |
| bl_co          | 編集可     | コンボボックスセル |
| bl_co_ne       | 編集可     | コンボボックスセル(ReadOnly) |
| bl_cotxt       | 編集可     | 入力可コンボボックスセル |
| bl_cotxt_ne    | 編集不可   | コンボボックスセル(ReadOnly) |
| bl_coro        | 編集不可   | コンボボックスセル(ReadOnly) |
| bl_ch          | 編集可     | チェックボックス編集セル |
| bl_ch_ne       | 編集可     | チェックボックスセル(readOnly) |
| bl_ch2         | 編集可     | チェックボックス編集セル(編集不可時も操作可能,表示対象の選択などを行う際の利用を想定している。) |

Blender拡張セル(excells配下のjs)
bl_link,bl_linknについては、標準のマッピング定義済

| セル種別名称   | 編集可否   | セル種別の説明            |
|:---------------|:-----------|:--------------------------|
| bl_btn         | 編集可     | Button付き編集セル |
| bl_btn_ne      | 編集不可   | Button付き編集セル(ReadOnly) |
| bl_calendar    | 編集可     | BlenderCalendar付き編集セル(テキスト入力不可) |
| bl_calendarA   | 編集可     | BlenderCalendar付き編集セル(テキスト入力可) |
| bl_color       | 編集可     | ColorPicker付き編集セル |
| bl_pwd         | 編集可     | パスワード用編集セル(入力文字を指定文字で隠す) |
| bl_ra_str      | 編集可     | 行方向ラジオボタン(行単位でグループ化) |
| bl_runbtn      | 編集可     | 実行釦付きセル(計算実行処理等の釦) |
| bl_link        | 編集可     | Hyperlink付き編集セル(ReadOnly) |
| bl_linkn       | 編集可     | Hyperlink付き数値編集セル(ReadOnly) |

Blender拡張業務セル(blenderbizcell.js)

| セル種別名称      | 編集可否   | セル種別の説明            |
|:------------------|:-----------|:--------------------------|
| bz_edn_notlinked  | 編集可     | 未連係データ編集セル(欠測データ非対応) |
| bz_ron_notlinked  | 編集不可   | 未連係データ編集セル(欠測データ非対応,readOnly) |
| bz_edn_linked     | 編集可     | 連係済データ編集セル(欠測データ非対応) |
| bz_ron_linked     | 編集可     | 連係済データ編集セル(欠測データ非対応,readOnly) |
| bz_edn_linked_ne  | 編集可     | 連係済データ編集セル(欠測データ非対応,readOnly,編集不可) |

@module BlenderCell
@main BlenderCell
**/

// --- 使用方法
// ex) 列index=1(=２列目)の数値書式を 0,000.00 に設定
//   grid.setNumberFormat("0,000.00", 1);
//
// ex) 行ID="row_1"、列index=1(=２列目)の数値書式を 0,000.00 に設定
//   grid1.setCellNumberFormat("row_1", 1, "0,000.00");
//
// ex) 列index=1(=２列目)のセレクタの内容を設定
//   grid.putAttribute("cell-combo[*-1]",
//        [["01","A支店"],["02","B支店"],["03","C支店"],["04","D支店"],["05","E支店"],
//         ["06","F支店"],["07","G支店"],["08","H支店"],["09","I支店"],["10","J支店"]]);
//
// ex) 行ID="row_1"、列index=1(=２列目)のセレクタの内容を設定
//   grid.putAttribute("cell-combo[row_1-1]",
//        [["01","A支店"],["02","B支店"],["03","C支店"],["04","D支店"],["05","E支店"],
//         ["06","F支店"],["07","G支店"],["08","H支店"],["09","I支店"],["10","J支店"]]);
//
// ex) 列index=1(=２列目)のセレクタの高さを 9 に設定
//   grid.putAttribute("cell-combo-size[*-1]", 9);

var BL_IMG_EDITABLE  = "bl-editable-mark.png";
var BL_IMG_READ_ONLY = "bl-readonly-mark.png";

var BL_DEFAULT_VALUE_COLOR = "gray";

var EDITABLE_MARK = "editMk";
//var BL_DIV_EDITABLE = "<div class='editableMk1'><div class='editableMk2'></div><div class='editableMk3'></div></div>";
//var BL_DIV_READ_ONLY = "<div class='readonlyMk'></div>";

/**
 * eXcell操作ユーティリティ
 *
 * @module BlenderCell
 * @class BlenderExCellUtil
 * @constractor
 */
function BlenderExCellUtil() {
}

BlenderExCellUtil._makeHtml = function(eXcell, colIndex, editable, valColor, horAlign, dispVal, img, needNumberFont, isVisibleEditableMark, needPreTag) {
	return BlenderExCellUtil._makeHtmlDiv(eXcell, colIndex, editable, valColor, horAlign, dispVal, img, needNumberFont, isVisibleEditableMark, needPreTag);
}

BlenderExCellUtil._makeHtmlImg = function(eXcell, colIndex, editable, valColor, horAlign, dispVal) {
	var imgPath = grid.imgURL;

	var markImg = BL_IMG_READ_ONLY;
	if( editable ) {
		markImg = BL_IMG_EDITABLE;
	}

	var html = "";
	if( eXcell.getHorAlign()=="left" ) {
		html = "<div style='padding:0px'>"+
//			"<div style='overflow:hidden;float:left;text-align:left;color:"+valColor+"'>"+dispVal+"</div>"+
			"<div style='overflow:hidden;float:left;text-align:left;'>"+dispVal+"</div>"+
			"<img src='"+imgPath+markImg+"' width='4' height='4' style='float:right;width:5px;margin-right:1px'/>"+
			"</div>";
	}else {
		html = "<div style='padding:1px 0px;word-break:break-all;'>"+
			"<img src='"+imgPath+markImg+"' width='4' height='4' style='float:right;width:5px;margin-right:1px'/"+
//			"<div style='overflow:hidden;float:"+horAlign+";text-align:"+horAlign+";color:"+valColor+"'>"+dispVal+"</div>"+
			"<div style='overflow:hidden;float:"+horAlign+";text-align:"+horAlign+";'>"+dispVal+"</div>"+
			"</div>";
	}

	return html;
}

BlenderExCellUtil._makeHtmlDiv = function(eXcell, colIndex, editable, valColor, horAlign, dispVal, img, needNumberFont, isVisibleEditableMark, needPreTag) {

//	var markDiv = BL_DIV_READ_ONLY;
//	if( editable ) {
//		markDiv = BL_DIV_EDITABLE;
//	}
	//alert("txtColor: "+txtColor);

	var paddingX = "0px";
	var paddingImgX = "2px";
	if( horAlign=="right" ) {
		paddingX = "6px";
	}
	if( editable && !(!(typeof isVisibleEditableMark === "undefined") && isVisibleEditableMark==false) ) {
		eXcell.addClass(EDITABLE_MARK);
		paddingImgX = "6px";
	} else {
		eXcell.removeClass(EDITABLE_MARK);
	}

	var imgDiv = "";
	if( img ) {
		imgDiv = "<div style='float:right;width:18px;padding-right:"+paddingImgX+"'>"+
			 "<img src='"+eXcell.grid.imgURL+img+"'>"+
			 "</div>";
	}

	var numberFont = "";
	if( needNumberFont ) {
		numberFont = ";font-family: \"MS Gothic\";font-size:12px";
	}

	if( needPreTag ) {
		dispVal = "<pre style='display: table-cell;'>"+dispVal+"</pre>";
	}

	if( horAlign!="center" ) {
		var html = "<div style='padding:1px "+paddingX+";word-break:break-all;'>"+imgDiv+
//			"<div style='float:right;width:5px;margin-right:1px;clear:left;height:0.01px;'>"+markDiv+"</div>"+imgDiv+
	//		"<div style='overflow:hidden;float:"+horAlign+";text-align:"+horAlign+";color:"+valColor+numberFont+"'>"+dispVal+"</div>"+
			"<div style='overflow:hidden;float:"+horAlign+";text-align:"+horAlign+numberFont+"'>"+dispVal+"</div>"+
			"</div>";
	} else {
		var html = "<div style='padding:1px "+paddingX+";word-break:break-all;'>"+imgDiv+
//		"<div style='float:right;width:5px;margin-right:1px;clear:left;height:0.01px;'>"+markDiv+"</div>"+imgDiv+
		"<div style='overflow:hidden;text-align:"+horAlign+numberFont+"'>"+dispVal+"</div>"+
		"</div>";
	}

	return html;
}

BlenderExCellUtil._getDataTagChildIdx = function(eXcell) {
	return (!eXcell.hasIcon() ? 0 : 1);
}

BlenderExCellUtil._getText = function(eXcell,considerPrevTag) {
	var ret = null;
	if( considerPrevTag ) {
		if( !eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)] ) ret = null;
		else if( !eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)].firstChild ) ret = null;
		else ret = eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)].firstChild.innerHTML;
	}else {
		if( !eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)] ) ret = null;
		else ret = eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)].innerHTML;
	}
	return ret;
}

BlenderExCellUtil._getCoText = function(eXcell) {
	return eXcell.cell.firstChild.childNodes[0].innerHTML;
}

BlenderExCellUtil._setTextColor = function(eXcell,color) {
	if(color && color!="") {
		eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)].style.color=color;
	}else {
		$(eXcell.cell.firstChild.childNodes[BlenderExCellUtil._getDataTagChildIdx(eXcell)]).css('color','');
	}
}

BlenderExCellUtil._setCoTextColor = function(eXcell,color) {
	if(color && color!="") {
		eXcell.cell.firstChild.childNodes[0].style.color=color;
	}else {
		$(eXcell.cell.firstChild.childNodes[0]).css('color','');
	}
}

BlenderExCellUtil._aplNFb2 = function(data, eXcell){
	var a = BlenderExCellUtil.getAttribute(eXcell.grid,eXcell.cell,"cell-number-format");
	if (!a)
		a = eXcell.grid._maskArr[eXcell.cell._cellIndex];
	if (!a)
		return data;

	var tmp = data.toString();
	if( a[7] ) {
		tmp = tmp.trim();
	}

	var ndata = parseFloat(tmp.replace(/[^0-9]*/g, ""));
	if (tmp.substr(0, 1) == "-")
		ndata = ndata*-1;

	var pfix = tmp.indexOf(".");
	if (pfix > -1)
		pfix = tmp.length-pfix-1;

	if (pfix > 0)
		ndata = ndata / Math.pow(10, pfix);
	return ndata;
}

BlenderExCellUtil._aplNF2 = function(data, eXcell){
	var a = BlenderExCellUtil.getAttribute(eXcell.grid,eXcell.cell,"cell-number-format");
	if (!a)
		a = eXcell.grid._maskArr[eXcell.cell._cellIndex];
	if (!a)
		return data;

	var c = (parseFloat(data) < 0 ? "-" : "")+a[2];

	data=Math.abs(Math.round(parseFloat(data)*Math.pow(10, a[0] > 0 ? a[0] : 0))).toString();
	data=(data.length < a[0] ?
		Math.pow(10, a[0]+1-data.length).toString().substr(1, a[0]+1)+data.toString() :
		data).split("").reverse();
	data[a[0]]=(data[a[0]]||"0")+a[4];

	if (a[1] > 0)
		for (var j=(a[0]>0 ? 0 : 1)+a[0]+a[1]; j<data.length; j+=a[1])
			data[j]+=a[5];

	data.reverse();

	if( a[0]!=a[6] ) {
		// フォーマットに # や _ が含まれていた場合は補正を行う。
		var breakFlag = false;
		var i=0;
		for( ; i<(a[0]-a[6]); i++ ) {
			//println("****>>>>> "+i+", "+data[data.length-1-i]);
			if( 0==data[data.length-1-i] ) {
				if( a[7] ) {
					data[data.length-1-i] = ' ';
				}else {
					data[data.length-1-i] = '';
				}
			}else {
				breakFlag = true;
				break;
			}
		}
		if( !breakFlag ) {
			if( data[data.length-1-i].indexOf(".")>0 ) {
				if( a[7] ) {
					data[data.length-1-i]
					 = data[data.length-1-i].replace(/[.]/g, " ");
				}else {
					data[data.length-1-i]
					 = data[data.length-1-i].replace(/[.]/g, "");
				}
			}
		}
	}
	var tmp = data.join("");

	//alert("c: ["+c+"], tmp: ["+tmp+"], a[3]: ["+a[3]+"], val: ["+c+tmp+a[3]+"]");

	return c+tmp+a[3];
}

BlenderExCellUtil.parseNumber = function(eXcell,val){
	val = (val!=eXcell.getEmptyValLabel() ? val : "");

	var ret = val;
	if( val && val.length>0 ) {
		var tmp = BlenderExCellUtil._aplNFb2(val, eXcell);
		var tmp2 = BlenderExCellUtil._aplNF2(tmp, eXcell);

		if( isNumber(tmp) && val==tmp2 ) {
			ret = tmp;
		}
	}
	return ret;
}

BlenderExCellUtil.formatNumber = function(eXcell,val){
	var ret = val;

	var tmp;
	if( eXcell.isEmptyVal(val) ){
		tmp = null;
	}else {
		if( isString(val) ) {
			if( isNumberStr(val) ) {
				if( val.trim().length>0 ) {
					tmp = Number(val);
				}else {
					tmp = null;
				}
			}else {
				tmp = null;
			}
		}else if( isNumber(val) ) {
			tmp = val;
		}
	}
	if( tmp != null ) {
		var tmp2 = BlenderExCellUtil._aplNF2(tmp, eXcell);
		var tmp3 = BlenderExCellUtil._aplNFb2(tmp2, eXcell);
		if( tmp==tmp3 ) {
			ret = tmp2;
		}
	}else {
		if( !val ) {
			ret = eXcell.getEmptyValLabel();
		}
	}
	return ret;
}

BlenderExCellUtil.escapeHTML = function(val) {
	var ret = val;
	if( isString(val) ) {
		ret = val.replace(/&/g,'&amp;').replace(/ /g,'&nbsp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
	}
	return ret;
}

BlenderExCellUtil.unescapeHTML = function(val) {
	var ret = val;
	if( isString(val) ) {
		ret = val.replace(/&lt;/g,'<').replace(/&nbsp;/g,' ').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
	}
	return ret;
}

/**
 * 指定のセルに設定されたアトリビュート値を取得する。
 *
 * @method getAttribute
 * @param grid {BlenderGrid} BlenderGrid
 * @param cell {[eXcell]} eXcell
 * @param attrName {string} アトリビュート名
 */
BlenderExCellUtil.getAttribute = function(grid,cell,attrName) {
	var rowId = cell.parentNode.idd;
	var colIdx = cell._cellIndex;

	var ret = grid.getAttribute(attrName+"["+rowId+"-"+colIdx+"]");
	if( ret == null ) {
		ret = grid.getAttribute(attrName+"[*-"+colIdx+"]");
		if( ret == null ) {
			ret = grid.getAttribute(attrName+"["+rowId+"-*]");
		}
	}
	return ret;
}

/**
 * bl_link, bk_btn の ^ 用特殊処理(1)文字列分割
 *
 * @method splitHatSpecial
 * @param val {string} 分割文字列(^)
 */
BlenderExCellUtil.splitHatSpecial = function (val) {
	var ret = [];
	var start = 0;
	var escape = false;

	for( var i=0; i<val.length; i++ ) {
		if( val.charAt(i)=='\\' ) {
			if( escape ) {
				escape = false;
			}else {
				escape = true;
			}
		}else if( val.charAt(i)=='^' ) {
			if( !escape ) {
				ret[ret.length] = val.substr(start,(i-start));
				start = i+1;
			}
			escape = false;
		}else {
			escape = false;
		}
	}

	if( start <= val.length ) {
		ret[ret.length] = val.substr(start,(val.length-start));
	}

	return ret;
}

/**
 * bl_link, bk_btn の ^ 用特殊処理(2)アンエスケープ
 *
 * @method unescapeHatSpecial
 * @param val {string} 分割文字列(^)
 */
BlenderExCellUtil.unescapeHatSpecial = function (val) {
	var ret = "";
	var start = 0;

	for( var i=0; i<val.length; i++ ) {
		if( val.charAt(i)=='\\'  ) {
			if( val.charAt(i+1)=='^'  ) {
				ret += val.charAt(i+1);
				i += 1;
			}else if( val.charAt(i+1)=='\\'  ) {
				ret += val.charAt(i);
				i += 1;
			}else {
				ret += val.charAt(i);
			}
		}else {
			ret += val.charAt(i);
		}
	}
	return ret;
}

/**
 * bl_link, bk_btn の ^ 用特殊処理(3)エスケープ
 *
 * @method escapeHatSpecial
 * @param id {string} 分割文字列(^)
 * @param label {string} ラベル
 */
BlenderExCellUtil.escapeHatSpecial = function (id,label) {
	var tmpLabel = "";
	for( var i=0; i<label.length; i++ ) {
		if( label.charAt(i)=='^'  ) {
			tmpLabel += "\\^";
		}else if( label.charAt(i)=='\\'  ) {
			tmpLabel += "\\\\";
		}else {
			tmpLabel += label.charAt(i);
		}
	}
	return id+"^"+tmpLabel;
}

/**
 * セルの文字色を参照する。(eXcell拡張)
 * スタイルが設定されていない場合は、""を返す。
 *
 * @class eXcell
 * @method getTextColor
 * @return {string} 文字色
 */
eXcell.prototype.getTextColor=function(){
	if (this.cell.style.color)
		return this.cell.style.color
	else
		return "";
}

/**
 * オリジナル値を参照する。(eXcell拡張)
 * @return オリジナル値
 */
eXcell.prototype.getOrgValue=function(){
	return this.getValue();
};

/**
 * テキスト値を参照する。(eXcell拡張)
 * @return テキスト値
 */
eXcell.prototype.getText=function(){
	return this.getValue();
};

/**
 * アイコン有無を判定する。(eXcell拡張)
 * @return アイコンがある場合true、ない場合false
 */
eXcell.prototype.hasIcon = function(){
	return false;
};

/**
 * CSSクラスが設定されているか確認する。(eXcell拡張)
 * @param className CSSクラス名
 * @return 指定したCSSクラスが適応されている場合true、されていない場合false
 */
eXcell.prototype.hasClass=function(className){
	return this.cell && jQuery.inArray( className, this.cell.className.split(/\s+/) ) > -1;
};

/**
 * CSSクラスを設定する。(eXcell拡張)
 * @param className CSSクラス名
 */
eXcell.prototype.addClass=function(classNames){
	var self = this;
	jQuery.each((classNames || "").split(/\s+/), function(i, className){
		if( !self.hasClass(className) ) {
			self.cell.className += (self.cell.className ? " " : "") + className;
		}
	});
};

/**
 * CSSクラスを削除する。(eXcell拡張)
 * @param className CSSクラス名
 */
eXcell.prototype.removeClass=function(classNames){
	classNames = (classNames || "").split(/\s+/);

	var self = this;
	this.cell.className = (classNames !== undefined ?
		jQuery.grep(self.cell.className.split(/\s+/), function(className){
			var ret = true;
			for( var i=0; i<classNames.length; i++ ) {
				if( classNames[i] == className ) {
					ret = false;
				}
			}
			return ret;
		}).join(" ") : "");
};

/**
 * 水平位置を取得する。(eXcell拡張)
 * @return 水平位置(left,center,right)
 */
eXcell.prototype.getHorAlign=function(){
	if (this.cell.style.textAlign)
		return this.cell.style.textAlign;
	else if (this.grid.cellAlign)
		return this.grid.cellAlign[this.cell._cellIndex];
	else
		return "left";
};

/**
 * ツールチップ用のタイトル情報を取得する。
 * @return ツールチップ用タイトル情報
 */
eXcell.prototype.getTitle=function(){
	return this.getText();
}

/**
 * HTML要素なしのテキスト情報を取得する
 * @return HTML要素なしのテキスト情報
 */
eXcell.prototype.getStrictText=function(){
	// IEの場合、子要素の階層が深いと、子階層DIVの分の改行が付加されてしまうため、1階層下を対象にする
	var targetCell = (this.cell.children.length > 0) ? this.cell.children[0] : this.cell;
	// innerTextまたはtextContentから取得
	return (_isIE ? targetCell.innerText : targetCell.textContent);
}

/**
 * 編集マークを非表示にする。
 */
eXcell.prototype.hiddenEditableMark=function(){
	this.removeClass(EDITABLE_MARK);
}

/**
 * ## Blender編集セル
 *
 * @module BlenderCell
 * @class eXcell_bl_ed
 * @extends [eXcell_ed]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_ed(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.visibleEditableMark=function(){return true};
	this.isDisabled=function(){return false};
	this.getValue = function(){
		var val = "";

		if( !this.grid.defaultValueSupport ) {

			val = this.parseVal(this.getText());

		}else {

			if( $(this.cell).data("entered")==true ) {
				val = this.parseVal(this.getText());
			}

		}

		return val;
	};
	this.getText = function() {
		return this.unescapeVal(BlenderExCellUtil._getText(this, this.isNeedPreTag()));
	}
	this.setValue=function(val){
		var vals = this.preprocess(val);
		var valColor = this.getValueColor(vals[0]);
		var dispVal = this.formatVal(vals[1]);
		dispVal = this.escapeVal(dispVal);
		dispVal = this.trimVal(dispVal);
		var html = BlenderExCellUtil._makeHtml(this,
			this.cell._cellIndex,
			!this.isDisabled(),
			valColor,
			this.getHorAlign(),
			dispVal,
			null,
			this.isNeedNumberFont(),
			true,
			this.isNeedPreTag());

		this.cell.orgVal = val;
		this.setCValue(html, val);
		// getValueColorが取得できた場合のみ
		//if(valColor&&valColor!="") this.setTextColor(valColor);
		if(null!=valColor) this.setTextColor(valColor);
	}
	this.preprocess=function(val) {
		var ret;

		if( !this.grid.defaultValueSupport ) {

			ret = ["", val];

		}else {
			var defaultVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"default-cell-data");

			if( val===null || val==="" ) {
				ret = [null, defaultVal];
				$(this.cell).data("entered", false);
			}else {
				ret = [val, val];
				$(this.cell).data("entered", true);
			}

		}

		return ret;
	}
	this.getValueColor=function(val) {
		var color;

		if( !this.grid.defaultValueSupport ) {

			color = this.getTextColor();

		}else {
			if( val===null ) {
				color = BL_DEFAULT_VALUE_COLOR;
			}else {
				color = this.getTextColor();
				if( color!=null && color!=""  ) {
					color = "";
				}
			}

		}

		return color;
	}
	this.getOrgValue=function(){
		return this.cell.orgVal;
	}
	this.parseVal = function(val){
		return (val&&(val!=this.getEmptyValLabel()) ? val : "");
	}
	this.formatVal = function(val){
		return (this.isEmptyVal(val) ? this.getEmptyValLabel() : val);
	}
	this.escapeVal = function(val){
		return BlenderExCellUtil.escapeHTML(val);
	}
	this.unescapeVal = function(val){
		return BlenderExCellUtil.unescapeHTML(val);
	}
	this.trimVal = function(val){
		return val.toString().replace(/\t/g,' ').replace(/\r\n/g,'').replace(/\n/g,'');
	}
	this.setTextColor=function(val){
		if(val&&val!="") {
			this.cell.style.color=val;
		}else {
			$(this.cell).css('color','');
		}
		BlenderExCellUtil._setTextColor(this,val);
	};
	this.isEmptyVal = function(val) {
		if( val==null ) return true;
		else return !(val.toString().trim().length>0);
	}
	this.getEmptyValLabel = function() {
		return "";
	}
	this.isNeedNumberFont = function() {
		return false;
	}
	this.isNeedPreTag = function() {
		return false;
	}
	this.getImeMode = function() {
		return null;
	}
	this.detach=function(silent){
		// IMEを起動中の編集セルからフォーカスを外すと値の設定にsetValueが使われない問題に仮対応
		var _detach_eXcell = this;
		var _detach_editorValue = this.obj.value;
		if(!silent) {
			// silentパラメータ追加。trueの場合は再設定しない
			setTimeout(function(){
				_detach_eXcell.setValue(_detach_editorValue);
			},10);
		}
		this.setValue(_detach_editorValue);
		return this.val !== this.getValue();
	}
	this.edit=function(){
		this.cell.atag=((!this.grid.multiLine)&&(_isKHTML||_isMacOS||_isFF)) ? "INPUT" : "TEXTAREA";
		this.val=this.getValue();
		this.obj=document.createElement(this.cell.atag);
		this.obj.setAttribute("autocomplete", "off");
		this.obj.style.height=(this.cell.offsetHeight-(_isIE ? 4 : 4))+"px";
		if( this.getImeMode() ) {
			this.obj.style.imeMode=this.getImeMode();
		}
		this.obj.className="dhx_combo_edit";
		this.obj.wrap="soft";
		this.obj.style.textAlign=this.getHorAlign();//this.cell.style.textAlign;
		this.obj.onclick=function(e){
			(e||event).cancelBubble=true
		};
		this.obj.onmousedown=function(e){
			(e||event).cancelBubble=true
		};
		this.obj.value=this.val
		this.cell.innerHTML="";
		this.cell.appendChild(this.obj);
		if (_isFF){
			this.obj.style.overflow="visible";
			if ((this.grid.multiLine)&&(this.obj.offsetHeight >= 18)&&(this.obj.offsetHeight < 40)){
				this.obj.style.height="36px";
				this.obj.style.overflow="scroll"
			}
		};
		this.obj.onselectstart=function(e){
			if (!e)e=event;
			e.cancelBubble=true;
			return true
		};
		if (_isIE)this.obj.focus();
		this.obj.focus();

		var inputFld = this.obj;
		setTimeout(function(){
			inputFld.select();
		},10);
	};
};

eXcell_bl_ed.prototype = new eXcell_ed;

/**
 * ## Blender漢字編集セル(入力時IME=ON)
 *
 * @class eXcell_bl_edk
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_edk(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.getImeMode = function() {
		return "active";
	}
};

eXcell_bl_edk.prototype = new eXcell_bl_ed;

/**
 * Blenderアルファベット編集セル(入力時IME無効)
 *
 * @module BlenderCell
 * @class eXcell_bl_eda
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_eda(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.getImeMode = function() {
		return "disabled";
	}
};

eXcell_bl_eda.prototype = new eXcell_bl_ed;

/**
 * Blender数値編集セル
 *
 * @class eXcell_bl_edn
 * @extends eXcell_bl_ed
 */

/**
 * Blender数値編集セルのデータトリミング有効/無効フラグ(デフォルト: 無効)。
 *
 * Excelからコピー&ペーストを実施する際、コピー元セルの書式設定を
 * "数値"にしていると値の末尾に半角スペースが付与される。
 * eXcell_bl_edn は半角スペースがあると入力値の数値変換に失敗するため
 * 数値変換前に trim する処理を追加し、これを有効にするためにフラグとして
 * 本定数を用意した。値を true に再定義することで、trim 処理が有効になる。
 *
 * eXcell_bl_edn.DATA_TRIMMING_ENABLE = true;
 *
 * @static
 * @final
 * @property {boolean} DATA_TRIMMING_ENABLE データトリミング有効/無効
 */
eXcell_bl_edn.DATA_TRIMMING_ENABLE = false;

/**
 * ## Blender数値編集セル
 *
 * @module BlenderCell
 * @class eXcell_bl_edn
 * @extends [eXcell_bl_ed]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_edn(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.parseVal = function(val){
		if( val && eXcell_bl_edn.DATA_TRIMMING_ENABLE ) {
			val = val.trim();
		}
		return BlenderExCellUtil.parseNumber(this,val);
	}

	var _super_preprocess = this.preprocess;

	this.preprocess = function(val) {
		if (val && eXcell_bl_edn.DATA_TRIMMING_ENABLE) {
			if (typeof val.trim === "function") {
				val = val.trim();
			}
		}
		return _super_preprocess.call(this, val); // 継承元の処理呼び出し
	}
	this.formatVal = function(val){
		return BlenderExCellUtil.formatNumber(this,val);
	}
	this.isNeedNumberFont = function() {
		return false;
	}
	this.getImeMode = function() {
		return "inactive";
	}
};

eXcell_bl_edn.prototype = new eXcell_bl_ed;

/**
 * Blender編集セル(Trim整形なし)
 *
 * @extends [eXcell_bl_ed]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_edsp(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.isEmptyVal = function(val) {
		if( val==null ) return true;
		else return !(val.toString().length>0);
	}
};

eXcell_bl_edsp.prototype = new eXcell_bl_ed;

/**
 * Blender編集セル(readOnly)
 *
 * @class eXcell_bl_ro
 * @param cell eXcell_bl_ro
 * @see eXcell_bl_ed
 */
function eXcell_bl_ro(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.isDisabled=function(){return true};
	this.edit=function(){};
};

eXcell_bl_ro.prototype = new eXcell_bl_ed;

/**
 * Blender数値編集セル(readOnly)
 * @see eXcell_bl_edn
 */
function eXcell_bl_ron(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.isDisabled=function(){return true};
	this.isNeedNumberFont = function() {
		return false;
	}
	this.edit=function(){};
};

eXcell_bl_ron.prototype = new eXcell_bl_edn;

/**
 * Blender編集セル(readOnly、Trim整形なし)
 *
 * @class eXcell_bl_rosp
 * @see eXcell_bl_ro
 */
function eXcell_bl_rosp(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.isEmptyVal = function(val) {
		if( val==null ) return true;
		else return !(val.toString().length>0);
	}
};

eXcell_bl_rosp.prototype = new eXcell_bl_ro;

function eXcell_bl_ed_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
};

eXcell_bl_ed_ne.prototype = new eXcell_bl_ro;

function eXcell_bl_edk_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
};

eXcell_bl_edk_ne.prototype = new eXcell_bl_ro;

function eXcell_bl_eda_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
};

eXcell_bl_eda_ne.prototype = new eXcell_bl_ro;

function eXcell_bl_edn_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
};

eXcell_bl_edn_ne.prototype = new eXcell_bl_ron;

/**
 * BlenderHTMLセル(readOnly)
 *
 * @class eXcell_bl_html
 * @extends [eXcell_bl_ed]
 */

/**
 * BlenderHTMLセルのTooltip無効化フラグ(デフォルト: 無効化有効)。
 *
 * ヘッダーセルのTooltipの非表示の要件にデフォルトは無効化されている。
 * 有効化にしたい場合、値を false に再定義することで、Tooltipが有効化になる。
 *
 * eXcell_bl_html.DISABLE_TOOLTIP = false;
 *
 * @static
 * @final
 * @property {boolean} DISABLE_TOOLTIP Tooltip無効化フラグ
 */
eXcell_bl_html.DISABLE_TOOLTIP = true;

/**
 * ## BlenderHTMLセル(readOnly)
 *
 * @class eXcell_bl_html
 * @extends [eXcell_bl_ed]
 * @module BlenderCell
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_html(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
	}
	this.isDisabled=function(){return true};
	this.escapeVal = function(val){
		return val;
	}
	this.unescapeVal = function(val){
		return val;
	}
	this.edit=function(){};
	this.getTitle=function(){
		return (eXcell_bl_html.DISABLE_TOOLTIP) ? "" : this.getText();
	};
	this.getText = function(){
		return BlenderExCellUtil.unescapeHTML(BlenderExCellUtil._getText(this, this.isNeedPreTag()));
	}
	this.getValue = function(){
		return this.parseVal(this.unescapeVal(BlenderExCellUtil._getText(this, this.isNeedPreTag())));
	}
};

eXcell_bl_html.prototype = new eXcell_bl_ed;

/**
 * BlenderText入力セル。
 * 改行コードをセルデータとしてJSONに含める場合は \n を利用のこと。
 *
 * @class eXcell_bl_edtext
 * @extends [eXcell_bl_ed]
 * @constructor
 * @param cell {[eXcell]} eXcell
 * @see eXcell_bl_ed
 */
function eXcell_bl_edtext(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
		$(this.cell).attr("valign", "top");
	}
//	this.escapeVal = function(val){
//		return "<pre style='display:table-cell'>"+BlenderExCellUtil.escapeHTML(val)+"</pre>";
//	}
//	this.unescapeVal = function(val){
//		var start = val.indexOf('>')+1;
//		var text = val.substr(start, val.lastIndexOf('<')-start);
//		return BlenderExCellUtil.unescapeHTML(text);
//	}
	this.trimVal = function(val){
		return val.toString().replace(/\t/g,' ').replace(/\r\n/g,'\n');
	}
	this.isNeedPreTag = function() {
		return true;
	}
	this.edit=function(){
		this.cell.atag=((!this.grid.multiLine)&&(_isKHTML||_isMacOS||_isFF)) ? "INPUT" : "TEXTAREA";
		this.val=this.getValue();
		this.obj=document.createElement(this.cell.atag);
		this.obj.setAttribute("autocomplete", "off");
		this.obj.style.height=(this.cell.offsetHeight-(_isIE ? 4 : 4))+"px";
		if( this.getImeMode() ) {
			this.obj.style.imeMode=this.getImeMode();
		}
		this.obj.className="dhx_combo_edit";
		this.obj.wrap="soft";
		this.obj.style.textAlign=this.getHorAlign();//this.cell.style.textAlign;
		this.obj.onclick=function(e){
			(e||event).cancelBubble=true
		};
		this.obj.onmousedown=function(e){
			(e||event).cancelBubble=true
		};
		this.obj.value=this.val

		this.obj.onkeydown=function(e){
			if( (e||event).keyCode==37
			 || (e||event).keyCode==38
			 || (e||event).keyCode==39
			 || (e||event).keyCode==40 ) {
				(e||event).cancelBubble=true;

			}else if( (e||event).keyCode==13 && (e||event).shiftKey ) {
				this.focus();
				(e||event).cancelBubble=true;
			}
		};

		this.cell.innerHTML="";
		this.cell.appendChild(this.obj);
		if (_isFF){
			this.obj.style.overflow="visible";
			if ((this.grid.multiLine)&&(this.obj.offsetHeight >= 18)&&(this.obj.offsetHeight < 40)){
				this.obj.style.height="36px";
				this.obj.style.overflow="scroll"
			}
		};
		this.obj.onselectstart=function(e){
			if (!e)e=event;
			e.cancelBubble=true;
			return true
		};
		if (_isIE)this.obj.focus();
		this.obj.focus();

		var inputFld = this.obj;
		setTimeout(function(){
			inputFld.select();
		},10);
	};
};

eXcell_bl_edtext.prototype = new eXcell_bl_ed;

/**
 * BlenderText表示セル(readOnly)
 * 改行コードをセルデータとしてJSONに含める場合は \n を利用のこと。
 *
 * @class eXcell_bl_rotext
 * @extends [eXcell_bl_edtext]
 * @constructor
 * @param cell {[eXcell]} eXcell
 * @see eXcell_bl_edtext
 */
function eXcell_bl_rotext(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.orgVal = "";
		$(this.cell).attr("valign", "top");
	}
	this.isDisabled=function(){return true};
	this.edit=function(){};
};

eXcell_bl_rotext.prototype = new eXcell_bl_edtext;

/**
 * ## Blenderコンボボックスセル
 * BlenderGrid の putAttribute によりコンボボックスの内容を設定する。
 *
 * ex) 全行の２列目(index=1)に設定
 * grid.putAttribute("cell-combo[*-1]",[[key1,val1],[key2,val2],...]);
 *
 * ex) rowId=3の３列目(index=2)に設定
 * grid.putAttribute("cell-combo[3-2]",[[key1,val1],[key2,val2],...]);
 *
 * @class eXcell_bl_co
 * @extends [eXcell_bl_edtext]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_co(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.initCombo = function() {
		if( !this.combo ) {
			this.combo = new dhtmlXGridComboObject();

			var comboVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo");
			//alert("comboVal: "+comboVal);
			if( comboVal ) {
				for( var i=0; i<comboVal.length; i++ ) {
					this.combo.put(comboVal[i][0], comboVal[i][1]);
				}
			}
		}
	}
	this.isDisabled=function(){return false};
	this.getValue = function(){
		var val = "";

		if( !this.grid.defaultValueSupport ) {

			val = this._getValue();

		}else {

			if( $(this.cell).data("entered")==true ) {
				val = this._getValue();
			}

		}

		return val;
	};
	this._getValue=function(){
		this.initCombo();

		var val = null;
		var text = this.getText();
		var comboKeys = this.combo.getKeys();
		for (var i=0; i<comboKeys.length; i++){
			var comboLabel = this.combo.get(comboKeys[i]);
			//alert("comboLabel: "+comboLabel+" vs text: "+text)
			if( comboLabel == text ) {
				val = comboKeys[i];
				break;
			}
		};
		return val;
	};
	this.getText = function() {
		//return BlenderExCellUtil._getCoText(this);
		//return BlenderExCellUtil._getText(this);
		return this.unescapeVal(BlenderExCellUtil._getText(this));
	}
	this.setValue=function(val){
		//alert("setValue: "+val);
		this.initCombo();

		var vals = this.preprocess(val);
		var valColor = this.getValueColor(vals[0]);
		var dispVal = this.combo.get(vals[1]);
		dispVal = this.escapeVal(dispVal);

		if( !dispVal ) dispVal = "";
		var html = BlenderExCellUtil._makeHtml(
			this,
			this.cell._cellIndex,
			!this.isDisabled(),
			valColor,
			this.getHorAlign(),
			dispVal);
		this.setCValue(html, val);
		// getValueColorが取得できた場合のみ
		//if(valColor&&valColor!="") this.setTextColor(valColor);
		if(null!=valColor) this.setTextColor(valColor);
	}
	this.preprocess=function(val) {
		var ret;

		if( !this.grid.defaultValueSupport ) {

			ret = ["", val];

		}else {
			var defaultVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"default-cell-data");

			if( val===null || val=="" ) {
				ret = [null, defaultVal];
				$(this.cell).data("entered", false);
			}else {
				ret = ["", val];
				$(this.cell).data("entered", true);
			}

		}

		return ret;
	}
	this.getValueColor=function(val) {
		var color;

		if( !this.grid.defaultValueSupport ) {

			color = this.getTextColor();

		}else {
			if( val===null ) {
				color = BL_DEFAULT_VALUE_COLOR;
			}else {
				color = this.getTextColor();
				if( color!=null && color!=""  ) {
					color = "";
				}
			}

		}

		return color;
	}
	this.setTextColor=function(val){
		if(val&&val!="") {
			this.cell.style.color=val;
		}else {
			$(this.cell).css('color','');
		}
		//BlenderExCellUtil._setCoTextColor(this,val);
		BlenderExCellUtil._setTextColor(this,val);
	};
	this.escapeVal = function(val){
		return BlenderExCellUtil.escapeHTML(val);
	}
	this.unescapeVal = function(val){
		return BlenderExCellUtil.unescapeHTML(val);
	}

	this.edit = function() {
		this.initCombo();

		this.val = this.getValue();
		this.text = this.getText()._dhx_trim();
		var arPos = this.grid.getPosition(this.cell)

		this.obj = document.createElement("TEXTAREA");
		this.obj.className = "dhx_combo_edit";
		this.obj.style.height = (this.cell.offsetHeight - 4) + "px";
		this.obj.style.float = "left";
		this.obj.wrap = "soft";
		this.obj.style.textAlign = this.cell.style.textAlign;
		this.obj.onclick = function(e) { (e || event).cancelBubble = true

		};
		this.obj.value = this.text
		this.obj.onselectstart = function(e) {
			if (!e) e = event;
			e.cancelBubble = true;
			return true
		};
		var editor_obj = this;
		this.obj.onkeyup = function(e) {
			var key = (e || event).keyCode;
			if (key == 38 || key == 40 || key == 9) return;
			var val = this.readonly ? String.fromCharCode(key) : this.value;
			var c = editor_obj.list.options;
			for (var i = 0; i < c.length; i++) if (c[i].text.indexOf(val) == 0)
			return c[i].selected = true
		};
		this.list = document.createElement("SELECT");
		this.list.className = 'dhx_combo_select';
		this.list.style.width = this.cell.offsetWidth + "px";
		this.list.style.left = arPos[0] + "px";
		//this.list.style.top = arPos[1] + this.cell.offsetHeight + "px";
		this.list.onclick = function(e) {
			var ev = e || window.event;
			var cell = ev.target || ev.srcElement


			if (cell.tagName == "OPTION") cell = cell.parentNode;
			editor_obj.setValue(cell.value);
			editor_obj.editable = false;
			editor_obj.grid.editStop()
		};
		var comboKeys = this.combo.getKeys();
		var fl = false
		var selOptId = 0;
		for (var i = 0; i < comboKeys.length; i++) {
			var val = this.combo.get(comboKeys[i])
			this.list.options[this.list.options.length] = new Option(val, comboKeys[i]);
			if (comboKeys[i] == this.val) {
				selOptId = this.list.options.length - 1;
				fl = true
			}
		};
		if (fl == false) {
			this.list.options[this.list.options.length] = new Option(this.text, this.val === null ? "": this.val);
			selOptId = this.list.options.length - 1
		};
		this.list.style.visibility = "hidden";
		document.body.appendChild(this.list)
		//this.list.size = "6";

		var listSize = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo-size");
		listSize = (listSize ? parseInt(listSize) : 6);
		if( comboKeys.length+1 < listSize ) {
			listSize = comboKeys.length+1; // サイズが1だとリスト形式ならないため+1を実施
		}
		this.list.size = ""+listSize;

		var listTop;
		if((arPos[1] + this.cell.offsetHeight + this.list.offsetHeight) < getPanelSize()[1]) {
			listTop = 0;
		}else {
			listTop = 0 - this.cell.offsetHeight - this.list.offsetHeight;
		}
		this.list.style.top = arPos[1] + this.cell.offsetHeight + listTop + "px";

		this.list.style.visibility = "visible";

		this.cstate = 1;
		if (this.editable) {
			this.cell.innerHTML = ""
		} else {
			this.obj.style.width = "1px";
			this.obj.style.height = "1px"
		};
		this.cell.appendChild(this.obj);
		this.list.options[selOptId].selected = true;
		if ((!_isFF) || (this.editable)) {
			this.obj.focus();
			this.obj.focus()
		};
		if (!this.editable) {
			this.obj.style.visibility = "hidden";
			this.list.focus();
			this.list.onkeydown = function(e) {
				e = e || window.event;
				editor_obj.grid.setActive(true)

				if (e.keyCode < 30) return editor_obj.grid.doKey({
					target: editor_obj.cell,
					keyCode: e.keyCode,
					shiftKey: e.shiftKey,
					ctrlKey: e.ctrlKey

				})

			}
		}
	};
};

eXcell_bl_co.prototype = new eXcell_co;

/**
 * Blender編集可コンボボックスセル
 * テキストフィールドとコンボボックスの組み合わせ。
 *
 * @class eXcell_bl_cotxt
 * @extends [eXcell_bl_co]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_cotxt(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}

	this.initCombo = function() {
		if( !this.combo ) {
			this.combo = new dhtmlXGridComboObject();

			var comboVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo");
			//alert("comboVal: "+comboVal);
			if( comboVal ) {
				// 非表示指定されたoptionを非表示にする
				var comboHiddenOptions = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo-hidden-options");

				for( var i=0; i<comboVal.length; i++ ) {
					if (!comboHiddenOptions || this.indexOf(comboHiddenOptions,comboVal[i][0]) === -1) {
						this.combo.put(comboVal[i][0], comboVal[i][1]);
					}
				}
			}
		}
	}

	this.indexOf = function(array, val) {
		for (var i = 0; i < array.length; i++){
			if (array[i] === val){
				return i;
			}
		}
		return -1;
	}

	this.getValue = function() {
		var val = "";

		if (!this.grid.defaultValueSupport || $(this.cell).data("entered")) {
			this.initCombo();
			var text = val = (this.getText() || val);
			var comboKeys = this.combo.getKeys();

			for (var i=0; i<comboKeys.length; i++){
				var comboLabel = this.combo.get(comboKeys[i]);

				if (comboLabel == text || comboKeys[i] == text) {
					// 特殊値ラベル表示対応。
//					val = comboKeys[i];
					var optionConvKeyMark = BlenderExCellUtil.getAttribute(this.grid,
							this.cell,"cell-combo-option-convKeyMark");
					if (optionConvKeyMark) {
						var firstChar = comboKeys[i].substr(0, 1);
						if (firstChar == optionConvKeyMark) {
							// convKeyMarkオプションによる特殊値ラベル表示対応
							// 例）
							// 　convKeyMarkが "#" に設定されていて、
							// 　選択肢 "#255": "未設定" が選択済みの場合、
							// 　値として "255" を返す。
							val = comboKeys[i].substr(1);
						} else {
							val = comboKeys[i];
						}
					} else {
						val = comboKeys[i];
					}
					break;
				}
			}
		}
		return val;
	};

	// 特殊値ラベル表示対応。
	this.getOrgValue = function() {
		var val = "";

		if (!this.grid.defaultValueSupport || $(this.cell).data("entered")) {
			// convKeyMarkオプションによる特殊値ラベル表示対応
			// 例）
			// 　convKeyMarkが "#" に設定されていて、
			// 　選択肢 "#255": "未設定" が選択済みの場合、
			// 　設定値 "255" に対して 内部値 "#255" を返す。

			this.initCombo();

			var text = val = (this.getText() || val);
			var comboKeys = this.combo.getKeys();

			for (var i = 0; i < comboKeys.length; i++) {
				var comboLabel = this.combo.get(comboKeys[i]);
				if (comboLabel == text || comboKeys[i] == text) {
					val = comboKeys[i];
					break;
				}
			};
		}
		return val;
	};

	this.findPreviousEnableOption = function(editorObj, options, idx) {

		for (var i = idx-1; i >= 0; i--) {

			if (options[i].disabled) {
				editorObj.findPreviousEnableOption(editorObj, options, i);
			} else {
				// 見つかったので、終了
				options[i].selected = true;
				editorObj.obj.value = options[i].text;
				return;
			}
		}
	}

	this.findNextEnableOption = function(editorObj, options, idx) {

		for (var i = idx+1; i < options.length; i++) {

			if (options[i].disabled) {
				editorObj.findNextEnableOption(editorObj, options, i);
			} else {
				// 見つかったので、終了
				options[i].selected = true;
				editorObj.obj.value = options[i].text;
				return;
			}
		}
	}

	this.getText = function() {
		return this.unescapeVal(BlenderExCellUtil._getText(this));
	}

	this.preprocess = function(val) {
		var ret;

		if (this.grid.defaultValueSupport) {
			if (val === null || val === "") {
				var defaultVal = BlenderExCellUtil.getAttribute(this.grid, this.cell, "default-cell-data");
				ret = [null, (defaultVal || "")];
				$(this.cell).data("entered", false);
			} else {
				ret = ["", val];
				$(this.cell).data("entered", true);
			}
		} else {
			ret = ["", (val || "")];
		}
		return ret;
	}

	this.getValueColor = function(val) {
		var color;

		if (this.grid.defaultValueSupport) {
			color = (val === null) ? BL_DEFAULT_VALUE_COLOR : "";
		} else {
			color = this.getTextColor();
		}
		return color;
	}

	this.setValue = function(val) {
		this.initCombo();
		var vals = this.preprocess(val);
		var valColor = this.getValueColor(vals[0]);
		var dispVal = this.combo.get(vals[1]);

		// 特殊値ラベル表示対応。
		var optionConvKeyMark = BlenderExCellUtil.getAttribute(this.grid, this.cell, "cell-combo-option-convKeyMark");
		if (!dispVal && optionConvKeyMark) {
			// convKeyMarkオプションによる特殊値ラベル表示対応
			// 例）
			// 　convKeyMarkが "#" に設定されていて、
			// 　選択肢 "#255": "未設定" が選択済みの場合、
			// 　設定値 "255" から 表示値 "未設定" を復元する。
			dispVal = this.combo.get(optionConvKeyMark + vals[1]);
		}

		if( !dispVal ) dispVal = val;
		dispVal = this.escapeVal(dispVal);
		var html = BlenderExCellUtil._makeHtml(
			this,
			this.cell._cellIndex,
			!this.isDisabled(),
			valColor,
			this.getHorAlign(),
			dispVal || vals[1]);

		this.setCValue(html, val);
		valColor != null && this.setTextColor(valColor);
	}

	this.escapeVal = function(val){
		return BlenderExCellUtil.escapeHTML(val);
	};

	this.unescapeVal = function(val){
		return BlenderExCellUtil.unescapeHTML(val);
	};

	this.edit = function() {
		this.initCombo();

		this.editable = true;

		// 特殊値ラベル表示対応。
//		this.val = this.getValue();
		// convKeyMarkオプションによる特殊値ラベル表示対応
		// 例）
		// 　convKeyMarkが "#" に設定されていて、
		// 　選択肢 "#255": "未設定" が選択済みの場合、
		// 　設定値 "255" を 内部値 "#255" に置き換える。
		this.val = this.getOrgValue();
		this.text = this.getText()._dhx_trim();
		var arPos = this.grid.getPosition(this.cell)

		this.obj = document.createElement("TEXTAREA");
		this.obj.className = "dhx_combo_edit";
		this.obj.style.height = (this.cell.offsetHeight - 4) + "px";
		this.obj.wrap = "soft";
		this.obj.style.textAlign = this.cell.style.textAlign;
		this.obj.onclick = function(e) { (e || event).cancelBubble = true

		};
		this.obj.value = this.text
		this.obj.onselectstart = function(e) {
			if (!e) e = event;
			e.cancelBubble = true;
			return true
		};
		var editor_obj = this;
		this.obj.onkeyup = function(e) {
			var key = (e || event).keyCode;
			if (key == 38 || key == 40 || key == 9) {
				return;
			}
			var val = this.readonly ? String.fromCharCode(key) : this.value;
			var c = editor_obj.list.options;
			for (var i = 0; i < c.length; i++) if (c[i].text.indexOf(val) == 0)
			return c[i].selected = true
		};
		this.list = document.createElement("SELECT");
		this.list.className = 'dhx_combo_select';
		this.list.style.width = this.cell.offsetWidth + "px";
		this.list.style.left = arPos[0] + "px";
		this.list.onclick = function(e) {
			var ev = e || window.event;
			var cell = ev.target || ev.srcElement;

			if (cell.tagName == "OPTION") cell = cell.parentNode;

			if (editor_obj.list.selectedIndex != -1
					&& !editor_obj.list.options[editor_obj.list.selectedIndex].disabled) {
					editor_obj._byClick=true;
					//editor_obj.setValue(cell.value);
	// 特殊値ラベル表示対応。
					// convKeyMarkオプションによる特殊値ラベル表示対応
					// 例）
					// 　convKeyMarkが "#" に設定されていて、
					// 　選択肢 "#255": "未設定" をクリックした場合、
					// 　値として "255" を設定する。
					var newValue = cell.value;
					var optionConvKeyMark = BlenderExCellUtil.getAttribute(editor_obj.grid
							,editor_obj.cell,"cell-combo-option-convKeyMark");
					if (optionConvKeyMark) {

						var firstChar = newValue.substr(0, 1);
						if (firstChar == optionConvKeyMark) {
							editor_obj.setValue(newValue.substr(1));
						} else {
							editor_obj.setValue(newValue);
						}
					} else {
						editor_obj.setValue(newValue);
					}
					editor_obj.editable=false;
				editor_obj.grid.editStop();
			} else {
				ev.cancelBubble = true;
			}
			editor_obj.editable = true;
		};
		var comboKeys = this.combo.getKeys();
		var selOptId = 0;
		for (var i = 0; i < comboKeys.length; i++) {
			var val = this.combo.get(comboKeys[i])
			var option = new Option(val, comboKeys[i]);

			// 非活性指定されたoptionを非活性化する
			var comboDisableOptions = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo-disabled-options");
			if( comboDisableOptions ) {
				for( var k=0; k<comboDisableOptions.length; k++ ) {
					if (comboDisableOptions[k] == comboKeys[i]) {
						option.disabled = true;
						break;
					}
				}
			}

			this.list.options[this.list.options.length] = option;
			if (comboKeys[i] == this.val) {
				selOptId = this.list.options.length - 1;
			}
		};

		this.list.style.visibility = "hidden";
		document.body.appendChild(this.list);

		var listSize = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo-size");
		listSize = (listSize ? parseInt(listSize) : 6);
		if( comboKeys.length+1 < listSize ) {
			listSize = comboKeys.length+1; // サイズが1だとリスト形式ならないため+1を実施
		}
		this.list.size = ""+listSize;

		var listTop;
		if((arPos[1] + this.cell.offsetHeight + this.list.offsetHeight) < getPanelSize()[1]) {
			listTop = 0;
		}else {
			listTop = 0 - this.cell.offsetHeight - this.list.offsetHeight;
		}
		this.list.style.top = arPos[1] + this.cell.offsetHeight + listTop + "px";

		this.list.style.visibility = "visible";

		this.cstate = 1;
		if (this.editable) {
			// 特殊値ラベル表示対応。
//			this.obj.value=this.val
			// convKeyMarkオプションによる特殊値ラベル表示対応
			// 例）
			// 　convKeyMarkが "#" に設定されていて、
			// 　選択肢 "#255": "未設定" が選択済みの場合、
			// 　"#255" を表示する代わりに "未設定" を表示する。
			var optionConvKeyMark = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo-option-convKeyMark");
			if (optionConvKeyMark) {

				var firstChar = this.val.substr(0, 1);
				// 先頭がconvKeyMarkではない場合のみ内部値を復元する（convKeyMarkの場合は表示値のままとする）
				if (firstChar !== optionConvKeyMark) {
					this.obj.value = this.val
				}
			} else {
				this.obj.value = this.val
			}

			this.obj.value=this.val
			this.cell.innerHTML="";
			if (_isFF){
				this.obj.style.overflow="visible";
				if ((this.grid.multiLine)&&(this.obj.offsetHeight >= 18)&&(this.obj.offsetHeight < 40)){
					this.obj.style.height="36px";
					this.obj.style.overflow="scroll"
				}
			};
		} else {
			this.obj.style.width = "1px";
			this.obj.style.height = "1px";
		};
		this.cell.appendChild(this.obj);
		this.list.options[selOptId].selected = true;
		if ((!_isFF) || (this.editable)) {
			this.obj.focus();
			this.obj.focus()
		};

		this.obj.onkeydown = function(e) {
			var key = (e || event).keyCode;
			if (key == 38) {
				// ↑キーの場合、disabledのoptionをスキップする
				var c = editor_obj.list.options;
				for (var i = 0; i < c.length; i++) {
					if (c[i].selected) {

						if (i-1 < 0) {

							if (!c[i].disabled) {
								// ↑キーで上に移動できなくなる場合、一番上の選択肢の値を表示編集エリアに表示する
								editor_obj.obj.value = c[i].text;
							}
						}

						for (var j = i-1; j >=0; j--) {
							if (c[j].disabled) {
								editor_obj.findPreviousEnableOption(editor_obj, c, j);
								(e || event).cancelBubble = true;
								return;
							} else {
								return;
							}
						}
					}
				}
			} else if (key == 40) {
				// ↓キーの場合、disabledのoptionをスキップする
				var c = editor_obj.list.options;

				for (var i = 0; i < c.length; i++) {
					if (c[i].selected) {
						for (var j = i+1; j < c.length; j++) {
							if (c[j].disabled) {
								editor_obj.findNextEnableOption(editor_obj, c, j);
								(e || event).cancelBubble = true;
								return;
							} else {
								return;
							}
						}

						// 最下部の選択の場合
						if (c[i].disabled) {
							(e || event).cancelBubble = true;
						}
					}
				}
			}
		}
	};

	this.detach = function (silent) {

//		if (this.obj.value !== "") {
		if (!this._byClick) {
			// テキスト入力の場合、以下処理を追加
			// IMEを起動中の編集セルからフォーカスを外すと値の設定にsetValueが使われない問題に仮対応
			var _detach_eXcell = this;
			var _detach_editorValue = this.obj.value;
			if(!silent) {
				// silentパラメータ追加。trueの場合は再設定しない
				setTimeout(function(){
					_detach_eXcell.setValue(_detach_editorValue);
				},10);
			}

	        this.list.parentNode && this.list.parentNode.removeChild(this.list);
	        this.obj.parentNode && this.obj.parentNode.removeChild(this.obj);
	        this.setValue(_detach_editorValue);

	        return this.val !== this.getValue();
		}

		if(this.val!=this.getValue()){
			this.cell.wasChanged = true;
		}

		if(this.list.parentNode!=null){
			if ((this.obj.value._dhx_trim()!=this.text)||(this._byClick)){
			//cell data was changed
			var cval=this.list.value;
			if (!this._byClick)
				this.combo.values[this.combo.keys._dhx_find(cval)]=this.obj.value;
				this.setValue(cval);
			}else{
				this.setValue(this.val);
			}
		}

		if(this.list.parentNode)
			this.list.parentNode.removeChild(this.list);
		if(this.obj.parentNode)
			this.obj.parentNode.removeChild(this.obj);

		return this.val!=this.getValue();
	}
};

eXcell_bl_cotxt.prototype = new eXcell_co;

/**
 * Blenderコンボボックスセル(readOnly)
 *
 * @class eXcell_bl_coro
 * @extends [eXcell_bl_co]
 * @constructor
 * @param cell {[eXcell]} eXcell
 * @see eXcell_bl_co
 */
function eXcell_bl_coro(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.combo = new dhtmlXGridComboObject();

		var comboVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo");
		//alert("comboVal: "+comboVal);
		if( comboVal ) {
			for( var i=0; i<comboVal.length; i++ ) {
				this.combo.put(comboVal[i][0], comboVal[i][1]);
			}
		}
	}
	this.isDisabled=function(){return true};
};

eXcell_bl_coro.prototype = new eXcell_bl_co;

function eXcell_bl_co_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.combo = new dhtmlXGridComboObject();

		var comboVal = BlenderExCellUtil.getAttribute(this.grid,this.cell,"cell-combo");
		//alert("comboVal: "+comboVal);
		if( comboVal ) {
			for( var i=0; i<comboVal.length; i++ ) {
				this.combo.put(comboVal[i][0], comboVal[i][1]);
			}
		}
	}
};

eXcell_bl_co_ne.prototype = new eXcell_bl_coro;

function eXcell_bl_cotxt_ne(cell){
	if (cell){
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
		this.initCombo();
	}

	this.isDisabled=function(){return true};
};

eXcell_bl_cotxt_ne.prototype = new eXcell_bl_cotxt;

/**
 * ## チェックボックスセル
 *
 * @class eXcell_bl_ch
 * @extends [eXcell]
 * @constructor
 * @param cell {[eXcell]} eXcell
 */
function eXcell_bl_ch(cell){
	if (cell){
		this.cell=cell;
		this.grid=this.cell.parentNode.grid;
		this.cell.obj=this
		this.hiddenEditableMark();
	};
	this.visibleEditableMark=function(){return false};
	this.disabledF=function(fl){
		if ((fl == true)||(fl == 1))
			this.cell.innerHTML=this.cell.innerHTML.replace("item_chk0.", "item_chk0_dis.").replace("item_chk1.","item_chk1_dis.");
		else
			this.cell.innerHTML=this.cell.innerHTML.replace("item_chk0_dis.", "item_chk0.").replace("item_chk1_dis.","item_chk1.")
	};
	this.changeState=function(){
		if ((!this.grid.isEditable)||(this.cell.parentNode._locked)||(this.isDisabled()))
			return;
		if (this.grid.callEvent("onEditCell", [0, this.cell.parentNode.idd, this.cell._cellIndex ])){
			this.val=this.getValue()

			if (this.val == "1")
				this.setValue("0")
			else
				this.setValue("1")

			this.cell.wasChanged=true;
			this.grid.callEvent("onEditCell", [1, this.cell.parentNode.idd, this.cell._cellIndex ]);
			this.grid.callEvent("onCheckbox", [this.cell.parentNode.idd, this.cell._cellIndex, (this.val != '1') ]);
			this.grid.callEvent("onCheck", [this.cell.parentNode.idd, this.cell._cellIndex, (this.val != '1') ])
		}else {
			this.editor=null
		}
	};
	this.getValue=function(){
		return this.cell.chstate ? this.cell.chstate.toString() : "0"
	};
	this.isCheckbox=function(){
		return true
	};
	this.isChecked=function(){
		if (this.getValue()== "1")
			return true;
		else
			return false
	};
	this.setChecked=function(fl){
		this.setValue(fl.toString())
	};
	this.detach=function(){
		return this.val != this.getValue()
	};
	this.edit=null
	this.getTitle=function(){
		return '';
	};
};

eXcell_bl_ch.prototype=new eXcell;

eXcell_bl_ch.prototype.setValue=function(val){
	this.cell.style.verticalAlign="middle";
	if (val){
		val=val.toString()._dhx_trim();
		if ((val == "false")||(val == "0")) val=""
	};
	if (val){
		val="1";
		this.cell.chstate="1"
	}else {
		val="0";
		this.cell.chstate="0"
	};
	var obj = this;
	this.setCValue("<div onclick='new eXcell_bl_ch(this.parentNode).changeState();(arguments[0]||event).cancelBubble=true;'><img src='"+this.grid.imgURL+"item_chk"+val+".gif'></div>",this.cell.chstate);
};

/**
 * チェックボックスセル(readOnly)
 *
 * @class eXcell_bl_ch_ne
 * @extends [eXcell_bl_ch]
 * @constructor
 * @param cell {[eXcell]} eXcell
 * @see eXcell_bl_ch
 */
function eXcell_bl_ch_ne(cell){
	if (cell){
		this.cell=cell;
		this.grid=this.cell.parentNode.grid;
		this.cell.obj=this
		this.hiddenEditableMark();
	};
	this.isDisabled=function(){return true};
};

eXcell_bl_ch_ne.prototype = new eXcell_bl_ch;

eXcell_bl_ch_ne.prototype.setValue=function(val){
	this.cell.style.verticalAlign="middle";
	if (val){
		val=val.toString()._dhx_trim();
		if ((val == "false")||(val == "0")) val=""
	};
	if (val){
		val="1";
		this.cell.chstate="1"
	}else {
		val="0";
		this.cell.chstate="0"
	};
	var obj = this;
	this.setCValue("<img src='"+this.grid.imgURL+"item_chk"+val+".gif'>",this.cell.chstate)
};


/**
 * ## チェックボックスセル(常時編集可)
 *
 * @class eXcell_bl_ch2
 * @extends [eXcell_bl_ch]
 * @constructor
 * @param cell {[eXcell]} eXcell
 * @see eXcell_bl_ch
 */
function eXcell_bl_ch2(cell){
	if (cell){
		this.cell=cell;
		this.grid=this.cell.parentNode.grid;
		this.cell.obj=this
		this.hiddenEditableMark();
	};
};

eXcell_bl_ch2.prototype = new eXcell_bl_ch;

/*
Copyright MITSUBISHI Elec.
*/
